import { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';
import { Tooltip, Whisper } from 'rsuite';
import { moeda, formataDataCompleta } from '../../components/funcoes';
import { MdRefresh } from 'react-icons/md';
import { FaBell, FaBellSlash, FaClipboardList } from 'react-icons/fa';
import Modal from '../../components/Modal';
import DetalhesPedido from '../../components/DetalhesPedido';
import { ContentHeader } from '../../components/ContentHeader';
import {
  Container,
  Content,
  ContentContainer,
  LoadingContainer,
  LoadingText,
  HeaderActions,
  HeaderBtn,
  HeaderIconBtn,
} from './styles';
import { useAuth } from '../../hooks/auth';
import PedidosLista from './PedidosLista';
import NotificationSound from '../../assets/sounds/notification.mp3';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getDataByStatus } from './utils';
import { orderTypes } from './constants';
import { useNotificationOrder } from '../../hooks/notificationOrder';
import DuvidasButton from '../../components/DuvidasButton';

export default function Pedidos() {
  const { user } = useAuth();
  const { hasPermission, requestPermission, pedidosLista, dispatch } =
    useNotificationOrder();
  const IdEmpresa = user?.IdEmpresa;
  const [audio] = useState(new Audio(NotificationSound));
  const [loading, setLoading] = useState(true);
  const [entregadores, setEntregadores] = useState([]);
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [pedidoSelecionado, setPedidoSelecionado] = useState({});
  const dataByStatus = getDataByStatus(pedidosLista);

  const loadOrders = useCallback(async () => {
    try {
      setLoading(true);

      const { data } = await api.get(`pedido/listarTodos/${IdEmpresa}`);

      dispatch({ type: 'LOAD_PEDIDOS', payload: data });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [IdEmpresa, dispatch]);

  const loadDeliveriesMans = useCallback(async () => {
    try {
      const res = await api.get(`Entregador/listar/${IdEmpresa}`);
      setEntregadores(res.data);
    } catch (error) {
      console.error(error);
    }
  }, [IdEmpresa]);

  const atualizar = useCallback(async () => {
    await loadOrders();
    await loadDeliveriesMans();
  }, [loadDeliveriesMans, loadOrders]);

  const abrirDados = (pedido) => {
    setPedidoSelecionado(pedido);
    setOpen(true);
  };

  useEffect(() => {
    atualizar();
  }, [atualizar, audio]);

  return (
    <Container>
      <ContentHeader
        title="Pedidos"
        subtitle="Acompanhe e gerencie os pedidos em tempo real"
        icon={FaClipboardList}
        thirdComponent={
          <HeaderActions>
            <Whisper
              placement="bottom"
              trigger="hover"
              speaker={
                <Tooltip>
                  {hasPermission
                    ? 'Notificações habilitadas'
                    : 'Notificações desabilitadas'}
                </Tooltip>
              }
            >
              <HeaderIconBtn
                $active={hasPermission}
                disabled={hasPermission}
                onClick={() => requestPermission()}
              >
                {hasPermission ? (
                  <FaBell size={14} />
                ) : (
                  <FaBellSlash size={14} />
                )}
              </HeaderIconBtn>
            </Whisper>
            <HeaderBtn onClick={() => history.push('/g_consultarpedidos')}>
              <FaClipboardList size={12} />
              Concluídos
            </HeaderBtn>
            <HeaderIconBtn onClick={atualizar} title="Atualizar">
              <MdRefresh size={18} />
            </HeaderIconBtn>
            <DuvidasButton tela="pedidos" />
          </HeaderActions>
        }
      />

      {loading ? (
        <LoadingContainer>
          <LoadingSpinner />
          <LoadingText>Carregando pedidos...</LoadingText>
        </LoadingContainer>
      ) : (
        <ContentContainer>
          <Content>
            {pedidosLista &&
              orderTypes.map((type) =>
                type !== 'AGENDAMENTO' ||
                dataByStatus.ordersByStatus[type]?.length > 0 ? (
                  <PedidosLista
                    key={type}
                    data={dataByStatus.ordersByStatus[type]}
                    valor={moeda(dataByStatus.totalByStatus[type])}
                    status={type}
                    onAbrirDados={abrirDados}
                    refresh={atualizar}
                  />
                ) : null,
              )}
          </Content>
        </ContentContainer>
      )}

      {open && (
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          pedido={pedidoSelecionado}
          refresh={(e) => console.info(e)}
          title={`Detalhes do pedido - #${pedidoSelecionado.Codigo}`}
        >
          <DetalhesPedido
            onClose={() => setOpen(false)}
            pedido={pedidoSelecionado}
            entregadores={entregadores}
            refresh={atualizar}
            formatarData={formataDataCompleta}
          />
        </Modal>
      )}
    </Container>
  );
}
